import type { HttpGet } from '@/shared/infra/http'
import type { ListHuntPackages, OutfitterPackage } from '@/shared/domain'

export class EdgeListHuntPackagesRepository {
  constructor(private readonly httpClient: HttpGet) {}

  execute: ListHuntPackages = async (params) => {
    const query = `?orgId=${params.orgId}&orgType=outfitter&packageType=internal`
    const response = await this.httpClient.get<{ packages: OutfitterPackage[] }>({
      url: `/bookings/packages${query}`,
    })
    return response.packages.filter((pkg) => pkg.isActive)
  }
}
